<script>
    import { fly } from "svelte/transition";
    
    import { clickOutside } from "../utils/click-outside";
    
    import ShopifyImage from "./ShopifyImage.svelte";
    import ProductImageGalleryModalItem from "./ProductImageGalleryModalItem.svelte";
    import { tick } from "svelte/internal";

    export let images = [];
    export let title = '';

    let currentImage;
    let isOpen = false;

    let container;

    let index = 0;

    let bgElement;

    const open = window.openImageModal = (image) => {
        currentImage = image || images[0];

        if (!isOpen) {
            isOpen = true;
            document.querySelector("body")?.classList.add("overflow-hidden");
        }

        tick().then(() => {
            document.getElementById('img-' + currentImage.id).scrollIntoView();
        });
    };
    
    export const close = () => {
        isOpen = false;
        document.querySelector("body")?.classList.remove("overflow-hidden");
    }

    function handleScroll (e) {
        const { scrollTop, scrollHeight } = e.target;
        const scrollPercentage = scrollTop / scrollHeight;

        index = Math.round(scrollPercentage * images.length);
    }

    let x = 'center';
    let y = 'center';

    function handleLeave (e) {
        x = 'center';
        y = 'center';
    }

    function handleMove (e) {
        let boundingRect = bgElement.getBoundingClientRect();
        boundingRect.height -= 50;

        let adjustedWidth = currentImage.width;
        let adjustedHeight = currentImage.height;
        
        x = 'center';

        if (boundingRect.width > boundingRect.height) {
            adjustedWidth = boundingRect.width;
            adjustedHeight = currentImage.height / currentImage.width * boundingRect.width;
        } else {
            adjustedWidth = currentImage.width / currentImage.height * boundingRect.height;
            adjustedHeight = boundingRect.height;
        }
        
        if (currentImage.width > boundingRect.width) {
            x = e.offsetX / boundingRect.width * (boundingRect.width - adjustedWidth) + 'px';
        }

        y = (e.offsetY / boundingRect.height * 0.8) * (boundingRect.height - adjustedHeight) + 'px';
    }

    $: container && document.getElementsByTagName('body')[0].appendChild(container);
</script>

<slot open={open} isOpen={(id) => isOpen && id === currentImage?.id}></slot>
{#if isOpen}
    <div bind:this={container} transition:fly|local={{y: -300}} class="fixed z-50 inset-0 bg-gray-500/50 backdrop-blur-lg md:py-8 md:px-16">
        <div 
            use:clickOutside={() => close()}
            class="relative shadow rounded-xl p-2 md:px-4 max-w-6xl bg-white mx-auto gap-4 grid h-full grid-rows-[3rem,auto] md:grid-rows-[3rem,auto,8rem]">
                <div class="sticky justify-between top-0 flex items-center gap-x-2">
                    <h2 class="font-medium">{title}</h2>

                    <button on:click={close} class="p-2 rounded-full">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6L6 18M6 6L18 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                </div>
            

                <div on:scroll={handleScroll} class="relative flex flex-wrap w-full f-full gap-4 md:hidden overflow-y-auto scroll-smooth snap-both snap-mandatory">
                    {#each images as image}
                        <ProductImageGalleryModalItem {image} {close} />
                    {/each}

                    <div class="fixed z-10 right-3 inset-y-0 flex items-center pointer-events-none">
                        <div class="bg-white/80 gap-2 inline-flex flex-col py-2 px-2 shadow justify-center rounded-full mx-auto">
                        {#each Array(images.length) as image,i}
                            <button class="bg-black h-2 w-2 rounded-full transition-colors" class:bg-yellow-500={index==i}></button>    
                        {/each}
                        </div>
                    </div>
                </div>

                <div class="bg-contain bg-no-repeat bg-center hover:bg-cover hidden md:block"
                    bind:this={bgElement}
                    on:mouseleave={handleLeave}
                    role="img"
                    style="background-image: url({currentImage.url}); background-position: {x} {y}"
                    on:mousemove={handleMove}></div>
                
                <div class="py-4 border-t  pl-2 hidden md:block">
                    <div class="flex gap-4 p-2 overflow-auto">
                        {#each images as image}
                            <div class="aspect-1 flex-shrink-0 ring-primary rounded-lg overflow-hidden" class:ring={image.url == currentImage.url}>
                                <button class="block" on:click={() => open(image)}>
                                    <img src="{image.url}&width=100&height=100" alt="{image.alt}" class="w-24 aspect-1 object-cover object-center" loading="eager" />
                                    
                                </button>
                            </div>
                        {/each}
                    </div>
                </div>
        </div>
    </div>
{/if}
